import React, { useState, useEffect } from 'react'
import { Card, Container, Row, Col, ListGroup } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import "../assets/styles/index.css"

const ProfileScreen = () => {
    const { userInfo } = useSelector((state) => state.auth)

    const [name, setName] = useState('')
    const [userId, setUserId] = useState('')
    const [fatherName, setFatherName] = useState('')
    const [profileImage, setProfileImage] = useState('')
    const [empCategory, setEmpCategory] = useState('')
    const [phone, setPhone] = useState('')
    const [gender, setGender] = useState('')
    const [designation, setDesignation] = useState('')
    const [companyName, setCompanyName] = useState('')
    const [department, setDepartment] = useState('')
    const [dob, setDob] = useState('')
    const [dateOfJoin, setDateOfJoin] = useState('')
    const [maritalStatus, setMaritalStatus] = useState('')
    const [esic, setEsic] = useState('')
    const [uan, setUan] = useState('')
    const [pan, setPan] = useState('')
    const [aadhar, setAadhar] = useState('')
    const [mobile, setMobile] = useState('')

    useEffect(() => {
        if (userInfo && userInfo.length > 0) {
            setUserId(userInfo[1]?.InfoField)
            setName(userInfo[2]?.InfoField)
            setFatherName(userInfo[3]?.InfoField)
            setEmpCategory(userInfo[4]?.InfoField)
            setPhone(userInfo[5]?.InfoField)
            setGender(userInfo[9]?.InfoField)
            setDesignation(userInfo[10]?.InfoField)
            setCompanyName(userInfo[13]?.InfoField1)
            setDepartment(userInfo[6]?.InfoField)
            setDob(userInfo[16]?.InfoField)
            setDateOfJoin(userInfo[17]?.InfoField)
            setMaritalStatus(userInfo[18]?.InfoField)
            setEsic(userInfo[19]?.InfoField)
            setUan(userInfo[20]?.InfoField)
            setPan(userInfo[21]?.InfoField)
            setAadhar(userInfo[22]?.InfoField)
            setMobile(userInfo[5]?.InfoField)

            const profileImage = userInfo && userInfo[12]?.InfoField
            const imageUrl = process.env.REACT_APP_URL + profileImage
            setProfileImage(imageUrl)
        }
    }, [userInfo])

    return (
        <Container className="profile-container">
            <Row className="justify-content-md-center">
                <Col md={8}>
                    <Card className="border-0 p-4 rounded shadow-sm profile-card">
                        <Card.Header className="text-center border-0 profile-header">
                            <img
                                src={profileImage}
                                alt="Profile"
                                className="rounded-circle mb-3 profileImage"
                            />
                            <h3 className="mt-2 text-white">{name}</h3>
                            <p className="text-white-50">{designation}</p>
                        </Card.Header>

                        <Card.Body>
                            <h5 className="section-title">Personal Details</h5>
                            <ListGroup variant="flush">
                                <ListGroup.Item className="profile-list-item">
                                    <div className="profile-key">Employee Code</div>
                                    <div className="profile-value">{userId}</div>
                                </ListGroup.Item>
                                <ListGroup.Item className="profile-list-item">
                                    <div className="profile-key">Name</div>
                                    <div className="profile-value">{name}</div>
                                </ListGroup.Item>
                                <ListGroup.Item className="profile-list-item">
                                    <div className="profile-key">Father's Name</div>
                                    <div className="profile-value">{fatherName}</div>
                                </ListGroup.Item>
                                <ListGroup.Item className="profile-list-item">
                                    <div className="profile-key">Phone</div>
                                    <div className="profile-value">{phone}</div>
                                </ListGroup.Item>
                                <ListGroup.Item className="profile-list-item">
                                    <div className="profile-key">Gender</div>
                                    <div className="profile-value">{gender}</div>
                                </ListGroup.Item>
                                <ListGroup.Item className="profile-list-item">
                                    <div className="profile-key">Date of Birth</div>
                                    <div className="profile-value">{dob}</div>
                                </ListGroup.Item>
                                <ListGroup.Item className="profile-list-item">
                                    <div className="profile-key">Marital Status</div>
                                    <div className="profile-value">{maritalStatus}</div>
                                </ListGroup.Item>
                                <ListGroup.Item className="profile-list-item">
                                    <div className="profile-key">PAN Number</div>
                                    <div className="profile-value">{pan}</div>
                                </ListGroup.Item>
                                <ListGroup.Item className="profile-list-item">
                                    <div className="profile-key">Aadhaar Number</div>
                                    <div className="profile-value">{aadhar}</div>
                                </ListGroup.Item>
                                <ListGroup.Item className="profile-list-item">
                                    <div className="profile-key">Mobile Number</div>
                                    <div className="profile-value">{mobile}</div>
                                </ListGroup.Item>
                            </ListGroup>

                            <h5 className="section-title mt-4">Company Details</h5>
                            <ListGroup variant="flush">
                                <ListGroup.Item className="profile-list-item">
                                    <div className="profile-key">Company Name</div>
                                    <div className="profile-value">{companyName}</div>
                                </ListGroup.Item>
                                <ListGroup.Item className="profile-list-item">
                                    <div className="profile-key">Date of join</div>
                                    <div className="profile-value">{dateOfJoin}</div>
                                </ListGroup.Item>
                                <ListGroup.Item className="profile-list-item">
                                    <div className="profile-key">Designation</div>
                                    <div className="profile-value">{designation}</div>
                                </ListGroup.Item>
                                <ListGroup.Item className="profile-list-item">
                                    <div className="profile-key">Department</div>
                                    <div className="profile-value">{department}</div>
                                </ListGroup.Item>
                                <ListGroup.Item className="profile-list-item">
                                    <div className="profile-key">ESIC Number</div>
                                    <div className="profile-value">{esic}</div>
                                </ListGroup.Item>
                                <ListGroup.Item className="profile-list-item">
                                    <div className="profile-key">UAN Number</div>
                                    <div className="profile-value">{uan}</div>
                                </ListGroup.Item>
                                <ListGroup.Item className="profile-list-item">
                                    <div className="profile-key">Employee Category</div>
                                    <div className="profile-value">{empCategory}</div>
                                </ListGroup.Item>
                            </ListGroup>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}

export default ProfileScreen
